export var InstructorTableRowType;
(function (InstructorTableRowType) {
    InstructorTableRowType["BLOCK"] = "block";
    InstructorTableRowType["INSTRUCTOR"] = "instructor";
})(InstructorTableRowType || (InstructorTableRowType = {}));
